import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Calendar, MapPin, Users, ArrowRight, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const prizeIcons = [Trophy, Calendar, MapPin, Users, ArrowRight];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut', delay },
});

export default function Prizes() {
  const { t } = useLanguage();
  const p = t.prizes;

  return (
    <section id="premios" className="py-14 md:py-20 bg-[#1A222B]" data-testid="prizes-section">
      <div className="section-container">
        <motion.div className="text-center mb-12" {...fadeUp()}>
          <div className="divider-gold mx-auto" />
          <h2 className="heading-lg mb-4">{p.title}</h2>
          <p className="text-[#8A9099] text-base max-w-xl mx-auto">{p.body}</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-10">
          {p.types.map((prize, i) => {
            const Icon = prizeIcons[i];
            return (
              <motion.div key={i} className="card-dark p-6 text-center" {...fadeUp(0.1 + i * 0.07)}
                data-testid={`prize-card-${i}`}>
                <div className="w-12 h-12 rounded-full bg-[#D5A63B]/10 border border-[#D5A63B]/20 flex items-center justify-center mx-auto mb-4">
                  <Icon size={20} className="text-[#D5A63B]" />
                </div>
                <h3 className="font-exo font-bold italic text-[#F3F1EB] text-sm mb-2">{prize.title}</h3>
                <p className="text-[#8A9099] text-xs leading-relaxed">{prize.desc}</p>
              </motion.div>
            );
          })}
        </div>

        {/* Podium note */}
        <motion.div className="bg-[#D5A63B]/8 border border-[#D5A63B]/25 rounded-xl p-5 mb-5 text-center"
          {...fadeUp(0.5)}>
          <div className="flex justify-center gap-3 mb-3">
            {['🥇', '🥈', '🥉'].map((m, i) => (
              <span key={i} className="text-2xl">{m}</span>
            ))}
          </div>
          <p className="text-[#D5A63B] font-semibold text-sm">{p.podium}</p>
        </motion.div>

        {/* Disclaimer */}
        <motion.div className="flex items-start gap-3 bg-[#0F6B49]/10 border border-[#0F6B49]/30 rounded-xl p-4"
          {...fadeUp(0.6)}>
          <Shield size={18} className="text-[#D5A63B] flex-shrink-0 mt-0.5" />
          <p className="text-[#D5A63B] font-bold text-sm font-exo italic">{p.disclaimer}</p>
        </motion.div>
      </div>
    </section>
  );
}
